import script from "./RowImageDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./RowImageDisplay.vue?vue&type=script&setup=true&lang=js"

import "./RowImageDisplay.vue?vue&type=style&index=0&id=870c78d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870c78d6"]])

export default __exports__